module.exports = __webpack_public_path__ + "img/page12-img.c315a415.png";